type PageType = 'article' | 'frontpage' | 'section' | 'topic' | 'search' | 'error';
type WallType = 'open' | 'paywall';

export function mapWallType (legacy: string | undefined | null): WallType | undefined {
  if (!legacy) { return undefined; }
  if (legacy === 'paywall') { return 'paywall'; }
  return 'open';
}

const LEGACY_PAGE_TYPE_MAP: Record<string, PageType> = {
  sectionpage: 'section',
  categorypage: 'section',
  latestpage: 'section',
  staticpage: 'section',
  tagpage: 'topic',
  searchpage: 'search'
};

export function mapPageType (legacy: string | undefined | null): PageType | undefined {
  if (!legacy) { return undefined; }
  if (legacy in LEGACY_PAGE_TYPE_MAP) { return LEGACY_PAGE_TYPE_MAP[legacy]; }
  return legacy as PageType;
}

export function toMilliseconds (timestamp: number | undefined | null): number | undefined {
  if (timestamp === null || timestamp === undefined || Number.isNaN(timestamp)) {
    return undefined;
  }
  return timestamp < 1e12 ? timestamp * 1000 : timestamp;
}

/* Grids with no placeholder ancestor are editor-desked edition rows. */
export const ZONE_TYPE_MANUAL = 'manual-desked';

/*
 * Placeholder types whose zone_type is not simply the type minus its
 * `cpp-` prefix. Everything else (cpp-collections, cpp-categories,
 * cpp-sections, cpp-streams, ...) is derived, so a new placeholder
 * type reports a sensible zone without an entry here.
 */
const ZONE_TYPE_MAP: Record<string, string> = {
  'cpp-mostread': 'most-read',
  'cpp-latestnews': 'latest-news',
  'cpp-editortoplist': 'editor-toplist'
};

/*
 * Placeholder types carry a publication suffix (`cpp-mostread-dn`,
 * `cpp-collections-common`), so key off the first two segments - the
 * same slicing DnPlaceholder uses to resolve its component.
 */
export function mapZoneType (placeholderType: string | undefined | null): string {
  const key = (placeholderType || '').split('-').slice(0, 2).join('-');
  if (!key) { return ZONE_TYPE_MANUAL; }
  if (key in ZONE_TYPE_MAP) { return ZONE_TYPE_MAP[key]; }
  return key.replace(/^cpp-/, '').toLowerCase() || ZONE_TYPE_MANUAL;
}
